import React from 'react'

const About = function (props) {
    return (
        <div>
            <p>JAWMDB (Jason Austin Watched Movies Data Base) App made by Jason and Austin.</p>
            <p>Github link: <a href="https://github.com/keposet/web3_asg1">https://github.com/keposet/web3_asg1</a></p>
            <br></br>
            <p>Film Metadata povided by <a href="https://www.themoviedb.org/">The Movie Database</a></p>
            <br></br>
            <p>Technology used:</p>
            <ul>
                <li>React-Modal: <a href="https://www.npmjs.com/package/react-modal">react-modal npm</a> </li>
                <li>React-Modal: <a href="https://www.npmjs.com/package/react-modal">react-modal npm</a> </li>
                <li>Loading svg "Flowing Gradient" from: <a href="https://icons8.com/preloaders/en/free"> icons8 Preloaders</a></li>
                <li>Logo Icon made by <a href="https://www.flaticon.com/authors/freepik" title="Freepik">Freepik</a> from <a href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a></li>
                <li>Hero Image <a href='https://images.unsplash.com/photo-1542204165-65bf26472b9b'>"8mm filmrolls"</a> From: Denise Jans <a href="https://unsplash.com/@dmjdenise">@dmjdenise</a></li>
                <li><a href="https://unsplash.com/photos/4PxJ_9wEQyI"></a>Curtain Image credit to unsplash user <a href="https://unsplash.com/@djpaine">DJ Paine</a></li>
                <li>Font Awesome Icons from <a href="https://fontawesome.com/how-to-use/on-the-web/using-with/react">react-fontawesome</a> </li>
                <li>CSSTransition Group used for <a href="http://reactcommunity.org/react-transition-group/css-transition">animations</a></li>
            </ul>
            <p>Code credit:</p>
            <ul>
                <li>React Router query sting basics from: <a href="https://tylermcginnis.com/react-router-query-strings/">Tyler McGinnis</a></li>
                <li>React CSSTransition basics from <a href="https://blog.logrocket.com/improve-your-ui-with-react-transition-group-999fa35f7cae/"> LogRocket.com</a></li>
                <li>CSS help: <a href="https://stackoverflow.com/questions/47881767/" >for adding commas</a> from user <a href="https://stackoverflow.com/users/5157454/ori-drori" >Ori Dori</a></li>
            </ul>
        </div>
    );
}

export default About;